import { Search, Bell, Command } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import { NAV_ITEMS } from '@/routes/nav';

export function Topbar() {
  const location = useLocation();
  const active = NAV_ITEMS.find((i) =>
    i.path === '/' ? location.pathname === '/' : location.pathname.startsWith(i.path),
  );

  const now = new Date();
  const dateLabel = now.toLocaleDateString('en-US', {
    weekday: 'long', month: 'long', day: 'numeric',
  });

  return (
    <header className="sticky top-0 z-20 h-16 bg-bg/80 backdrop-blur-md border-b border-border">
      <div className="h-full px-8 flex items-center gap-6">
        {/* Breadcrumb-style page title */}
        <div className="flex items-center gap-3 min-w-0">
          <span className="kicker text-text-dim">Portal</span>
          <span className="text-text-dim">/</span>
          <span className="kicker text-text">{active?.label ?? 'Page'}</span>
        </div>

        {/* Search */}
        <div className="flex-1 max-w-lg ml-8">
          <button className="group w-full h-9 flex items-center gap-3 px-3 bg-bg-subtle border border-border rounded-sm text-sm text-text-dim hover:border-border-strong transition-colors">
            <Search size={14} />
            <span className="flex-1 text-left">Search clients, orders, SKUs…</span>
            <span className="flex items-center gap-1 text-2xs">
              <kbd className="px-1.5 py-0.5 bg-bg border border-border rounded text-text-muted flex items-center gap-0.5">
                <Command size={10} /> K
              </kbd>
            </span>
          </button>
        </div>

        {/* Right cluster */}
        <div className="flex items-center gap-4 text-xs text-text-dim">
          <span className="hidden md:inline tabular">{dateLabel}</span>
          <button
            aria-label="Notifications"
            className="relative p-2 text-text-muted hover:text-text hover:bg-bg-hover rounded-sm transition-colors"
          >
            <Bell size={16} />
            <span className="absolute top-1.5 right-1.5 h-1.5 w-1.5 rounded-full bg-brass-400" />
          </button>
        </div>
      </div>
    </header>
  );
}
